import Vue from 'vue';
import { axiosSwagger } from "@/axios";
import _cloneDeep from 'lodash/cloneDeep';



export const state = {
    breadCrumb: {
        loading: false,
        data: [],
    },
    modifyBreadCrumb: {
        loading: false,
        data: [],
    },

    // for folder path
    displayBreadcrumb: {
        loading: false,
        data: [],
    }
}


export const getters = {
}


export const mutations = {
    // BREADCRUMB
    breadCrumbLoading: (state, loading) => {
        state.breadCrumb.loading = loading;
    },
    setBreadCrumbData: (state, data) => {
        state.breadCrumb.data = updateBreadCrumbData( data );

        // modify breadcrumbs
        const copyBreadcrumbData =  _cloneDeep(state.breadCrumb.data);
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setBreadCrumbDataV2: (state, data) => {
        state.breadCrumb.data = updateBreadCrumbDataV2( data );

        // modify breadcrumbs
        const copyBreadcrumbData =  _cloneDeep(state.breadCrumb.data);
        state.modifyBreadCrumb.data = modifiedBreadCrumb(copyBreadcrumbData);
    },
    setMyBreadCrumb: (state, data) => {
        if(data === null){
            state.breadCrumb.data, state.modifyBreadCrumb.data = [
                {
                    id: 0,
                    text: "My Office",
                    to: { name: "My Folder" },
                    parentId: null,
                }
            ]
        }
    },
    // FOR DISPLAY PATH
    displayBreadCrumbLoading: (state, loading) => {
        state.displayBreadcrumb.loading = loading;
    },
    setDisplayBreadCrumbData: (state, { data, type, item }) => {
        state.displayBreadcrumb.data = updateDisplayBreadCrumbData( data, type, item );
    },
}


export const actions = {
    // Get File Folder by Id

    // OBSOLETE CODE
    // async readFolderPathById({ commit }, id) {
    //     commit("breadCrumbLoading", true);

    //     return await getAllPath(id)
    //         .then(() => {
    //             commit("setBreadCrumbData", _path);
    //             _path = []; // reset path
    //         })
    //         .catch(() => {
    //             commit("breadCrumbLoading", false);
    //         });
    // },
    // OBSOLETE CODE

    async readFolderPathById({ commit }, id) {
        commit("breadCrumbLoading", true);

        return await axiosSwagger
        .   get(`/api/FileFolder/Details/${id}`)
            .then((response) => {
                commit("setBreadCrumbDataV2", response.data);
                commit("breadCrumbLoading", false);
            })
            .catch(() => {
                commit("breadCrumbLoading", false);
            });
    },
    // FOR DISPLAY PATH
    async readDisplayFolderPathById({ commit }, { id, type, item }) {
        commit("displayBreadCrumbLoading", true);

        return await axiosSwagger
        .   get(`/api/FileFolder/Details/${id}`)
            .then((response) => {
                commit("setDisplayBreadCrumbData", { data: response.data, type, item });
                commit("displayBreadCrumbLoading", false);
            })
            .catch(() => {
                commit("displayBreadCrumbLoading", false);
            });
    },
}


// let _path = [];
// async function getAllPath(id) {

//     await axiosSwagger
//         .get(`/api/FileFolder/GetFileFolderById/${id}`)
//         .then(async (response) => {
//             _path.unshift(response.data);

//             if(response.data.parentId !== null){
//                 await getAllPath(response.data.parentId);
//             }
//             else{
//                 return _path;
//             }
//         })
//         .catch(() => {
//             throw("error getAllPath");
//         })
// }



const updateBreadCrumbData = (data) => {
    if(data?.length ?? false){
        let _finalData = [
            {
                id: 0,
                text: "My Office",
                to: { name: "My Folder" },
                parentId: null,
            }
        ];

        data.forEach(e => {
            let encryptId = Vue.prototype.$encryptRouteID(e.id.toString());

            _finalData.push({
                id: e.id,
                text: e.name,
                to: {
                    name: 'Folder ID',
                    params: { id: encryptId }
                },
                parentId: e.parentId,
            })
        });

        return _finalData;
    }
}

const updateBreadCrumbDataV2 = (data) => {
    if(data?.pathDetails?.length || false){
        let _finalData = [
            {
                id: 0,
                text: "My Office",
                to: { name: "My Folder" },
                parentId: null,
            }
        ];

        data.pathDetails.forEach((e, i) => {
            let encryptId = Vue.prototype.$encryptRouteID(e.fileFolderId.toString());

            _finalData.push({
                id: e.fileFolderId,
                text: e.name,
                to: {
                    name: 'Folder ID',
                    params: { id: encryptId }
                },
                parentId: i+1 === data.pathDetails.length ? data?.parentId : e?.parentId,
            })
        });

        return _finalData;
    }
}


const updateDisplayBreadCrumbData = (data, type, item) => {
    if(data?.pathDetails?.length || false){
        let _finalData = [
            {
                id: 0,
                text: "My Office",
                to: { name: "My Folder" },
                parentId: null,
            }
        ];

        data.pathDetails.forEach((e, i) => {
            
            if(type === 'folder'){
                let encryptId = i+1 === data.pathDetails.length && item?.parentId ? Vue.prototype.$encryptRouteID(item.parentId.toString()) : Vue.prototype.$encryptRouteID(e.fileFolderId.toString());
    
                _finalData.push({
                    id: e.fileFolderId,
                    text: e.name,
                    to: item?.parentId ? {
                        name: 'Folder ID',
                        params: { id: encryptId }
                    } : 
                    { name: "My Folder" },
                    parentId: i+1 === data.pathDetails.length ? data?.parentId : e?.parentId,
                    type: type,
                })
            }
            else if(type === 'file'){
                let encryptId = Vue.prototype.$encryptRouteID(e.fileFolderId.toString());

                _finalData.push({
                    id: e.fileFolderId,
                    text: e.name,
                    to: {
                        name: 'Folder ID',
                        params: { id: encryptId }
                    },
                    parentId: i+1 === data.pathDetails.length ? data?.parentId : e?.parentId,
                    type: type,
                });

                if(i+1 === data.pathDetails.length){
                    _finalData.push({
                        id: item.id,
                        text: item.name,
                        to: {
                            name: 'Folder ID',
                            params: { id: encryptId }
                        },
                        parentId: i+1 === data.pathDetails.length ? data?.parentId : e?.parentId,
                        type: type,
                        icon: Vue.prototype.$getDocIcon( item?.fileManagerFiles ? item.fileManagerFiles : '' ),
                    });
                }
            }

        });

        return _finalData;
    }
}



const modifiedBreadCrumb = (data) => {
    if(data.length >= 4){
      const sliceData = data.slice(1, data.length-2);
  
      data.splice(1, data.length-3, sliceData);
      
      return data;
    }
  
    return data;
  };